import { render, staticRenderFns } from "./LikeCard.vue?vue&type=template&id=2039385c&scoped=true"
import script from "./LikeCard.vue?vue&type=script&lang=js"
export * from "./LikeCard.vue?vue&type=script&lang=js"
import style0 from "./LikeCard.vue?vue&type=style&index=0&id=2039385c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039385c",
  null
  
)

export default component.exports